import styled from 'styled-components'

const RoznicaCITRZiSHeaderStyle = styled.div`
  grid-area: main;

  .roznica-podatku-header {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 144px 144px;
    grid-template-areas: 'name from to';
    grid-column-gap: 16px;

    padding: ${props =>
      props.shortenedView ? '0 20px 4px 28px' : '0px 8px 4px 20px'};
    font-size: 11px;
    line-height: 1.45;
    letter-spacing: 0.4px;
    color: ${props => props.theme.black38};
  }

  .name {
    grid-area: name;
    display: flex;
    align-items: center;
  }

  .from {
    grid-area: from;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .to {
    grid-area: to;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
`
export default RoznicaCITRZiSHeaderStyle
